import { shallowMount } from "@vue/test-utils";
import RenaperConsultar from "@/views/RenaperConsultar";

describe("RenaperConsultar component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(RenaperConsultar);
  });

  it("Renders del component RenaperConsultar", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
